import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SalesOrders_ds_load_slip_order_lines_reportService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { orderId: number }): 
  Promise<{ result: { OrderId?: number, LineNumber?: number, LotId?: number, PackagedAmount?: number, Order?: { LookupCode?: string, Notes?: string, Project?: { LookupCode?: string, Name?: string, Owner?: { LookupCode?: string, Name?: string } }, PreferredCarrier?: { Name?: string }, PreferredWarehouse?: { Name?: string } }, Shipment?: { ConveyenceReference?: string, LookupCode?: string, PickupDate?: string, ReferenceNumber?: string }, Material?: { Description?: string, LookupCode?: string }, Lot?: { LookupCode?: string }, InventoryMeasurementUnit?: { ShortName?: string }, LotLocation?: { LicensePlateId?: number, LotId?: number, PackagedId?: number, LicensePlate?: { Id?: number, Location?: { Id?: number, Name?: string } } }, LotAvgWeight?: { AvgNetWeight?: number } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.orderId)) {
      missingRequiredInParams.push('\'orderId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SalesOrders/datasources/ds_load_slip_order_lines_report/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { orderId: number, $top?: number, $skip?: number }): 
  Promise<{ result: { OrderId?: number, LineNumber?: number, LotId?: number, PackagedAmount?: number, Order?: { LookupCode?: string, Notes?: string, Project?: { LookupCode?: string, Name?: string, Owner?: { LookupCode?: string, Name?: string } }, PreferredCarrier?: { Name?: string }, PreferredWarehouse?: { Name?: string } }, Shipment?: { ConveyenceReference?: string, LookupCode?: string, PickupDate?: string, ReferenceNumber?: string }, Material?: { Description?: string, LookupCode?: string }, Lot?: { LookupCode?: string }, InventoryMeasurementUnit?: { ShortName?: string }, LotLocation?: { LicensePlateId?: number, LotId?: number, PackagedId?: number, LicensePlate?: { Id?: number, Location?: { Id?: number, Name?: string } } }, LotAvgWeight?: { AvgNetWeight?: number } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.orderId)) {
      missingRequiredInParams.push('\'orderId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SalesOrders/datasources/ds_load_slip_order_lines_report/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { orderId: number, $keys: { OrderId?: number, LineNumber?: number }[] }): 
  Promise<{ result: { OrderId?: number, LineNumber?: number, LotId?: number, PackagedAmount?: number, Order?: { LookupCode?: string, Notes?: string, Project?: { LookupCode?: string, Name?: string, Owner?: { LookupCode?: string, Name?: string } }, PreferredCarrier?: { Name?: string }, PreferredWarehouse?: { Name?: string } }, Shipment?: { ConveyenceReference?: string, LookupCode?: string, PickupDate?: string, ReferenceNumber?: string }, Material?: { Description?: string, LookupCode?: string }, Lot?: { LookupCode?: string }, InventoryMeasurementUnit?: { ShortName?: string }, LotLocation?: { LicensePlateId?: number, LotId?: number, PackagedId?: number, LicensePlate?: { Id?: number, Location?: { Id?: number, Name?: string } } }, LotAvgWeight?: { AvgNetWeight?: number } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.orderId)) {
      missingRequiredInParams.push('\'orderId\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SalesOrders/datasources/ds_load_slip_order_lines_report/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      orderId: number    }) {
        if(isNil(inParams.orderId)) {
          return true; 
        }
      return false;
    }
}
